import React from 'react';
import { useConditionalFeature } from '@americanexpress/conditional-features';
import { RenderModule } from 'holocron';
import 'react-loading-skeleton/dist/skeleton.css';
import { hasGetInspiredRule } from '../../constants/featureRulesConstants';
import { GET_INSPIRED_FF } from '../../constants/oneXpConstants';
import { useFeatureFlagWithProperties } from '../../thunks/useFeatureFlagWithProperties';
import { PERSONALIZED_MAKETING_ARTICLES_MODULE_NAME } from '../../constants/modules';

export const InspirationArticles = () => {
  const getInspiredRuleInCodeFlag = useConditionalFeature(hasGetInspiredRule);
  const getInspiredOneXPEnabled = useFeatureFlagWithProperties(GET_INSPIRED_FF);
  const shouldDisplayGetInspired = getInspiredRuleInCodeFlag || getInspiredOneXPEnabled;

  if (!shouldDisplayGetInspired) {
    return null;
  }

  return (
    <div data-testid="axp-travel-home-just-for-you" className="pad-4-b pad-t-xs-down">
      <RenderModule
        moduleName={PERSONALIZED_MAKETING_ARTICLES_MODULE_NAME}
        props={{
          clientId: 'homepage',
          placementId: 'get-inspired',
        }}
      />
    </div>
  );
};
